import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { Button } from 'devextreme-react/button';
import { Column } from 'devextreme-react/data-grid';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { formatMessage } from 'devextreme/localization';
import SplitterLayout from 'react-splitter-layout';
import { DateBox, TextBox } from 'devextreme-react';
import PopupMVP from '../PopupMVP';
import HeaderButtonMVP from '../HeaderButtonMVP';
import DataGridMVP from '../DataGridMVP';
import columnDataGrid from './columnDataGrid';
import rollsColumnDataGrid from './rollsColumnDataGrid';
import {
  debounce,
  normalizeDateToSend,
  trim
} from '../../utils/functions';
import style from './recyclingorders.module.scss';

const RecyclingOrders = ({
  semiProductsReducer,
  settingsReducer: { settings },
  tabsReducer: { tabSelect },
  taskReducer,
  userReducer: { permissions, id },
  zdvlReducer: {
    defaultCheckedRollsKeys,
    error,
    okRequestClose,
    okRequestModal,
    okRequestRid,
    okRequestTie,
    okRequestUpdateZDVL,
    okRequestZDVLSendNotice,
    listZdvl,
    loadingClose,
    loadingData,
    loadingModal,
    loadingRolls,
    loadingUpdateZDVL,
    loadingZDVL,
    loadingZDVLSendNotice,
    statusData,
    visibleUpdateZDVL,
    zdvlRolls
  },
  closeZDVL,
  deleteReadyProducts,
  deleteTaskZdvlLine,
  getReportCreateNew,
  getZDVL,
  getZDVLAccept,
  getZDVLClear,
  getZDVLDecline,
  getZDVLRolls,
  getZDVLRollsFail,
  getZDVLSend,
  isSemiStock,
  modalErrorOpen,
  plantId,
  saveTask,
  updateZDVL,
  getZDVLSendNotice,
  updateZDVLModalClose,
  useProductionLg
}) => {
  const [headButtVisibol, setHeadButtVisibol] = useState({ display: 'none' });
  const [selectedRollsKeys, setSelectedRollsKeys] = useState(
    defaultCheckedRollsKeys
  );

  /** Модальное окна */
  const [modalData, setModalData] = useState({
    visibleModalSubscribe: false,
    visibleModalReject: false,
    visibleModalSend: false,
    visibleModalTie: false,
    visibleModalRid: false,
    visibleModalClose: false,
    visibleModalEmail: false
  });

  /** Выбор строк */
  const [dataSource, setDataSource] = useState({
    selectList: [],
    selectZdvlOrderNumId: null,
    orderStatus: null,
    orderId: null,
    lineStatus: null,
    taskDate: new Date(),
    taskNumber: null
  });

  /** Фильтры по таблицам */
  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    plantId,
    filter: ''
  });
  const [filterRollsDataGrid, setFilterRollsDataGrid] = useState({
    dateFrom: '',
    dateTo: ''
  });

  /** Данные по таблицам */
  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  const [rollsDataGridInstance, setRollsDataGridInstance] = useState({});

  /** Состояние поля для дополнительных получателей */
  const [emailsData, setEmailsData] = useState();

  /** Установка дефолтно выбранных рулонов */
  useEffect(() => {
    setSelectedRollsKeys(defaultCheckedRollsKeys);
  }, [defaultCheckedRollsKeys]);

  /** Открытие модального окна при успешной привязке рулонов */
  useEffect(() => {
    if (taskReducer.taskSave.okRequest || okRequestClose) {
      setModalData((prev) => ({
        ...prev,
        visibleModalTie: false,
        visibleModalClose: false
      }));
    }
  }, [taskReducer.taskSave.okRequest, okRequestClose]);

  /** Обновление данных при переключении на вкладку */
  useEffect(() => {
    if (id !== null && tabSelect === 7) {
      getZDVL({
        ...filterDataGrid,
        plantId
      });
    }
  }, [
    getZDVL,
    taskReducer.taskSave.okRequest,
    filterDataGrid,
    plantId,
    id,
    tabSelect,
    okRequestTie,
    okRequestClose,
    okRequestRid
  ]);

  useEffect(() => {
    if (
      id !== null
      && tabSelect === 7
      && okRequestModal
      && (modalData.visibleModalSubscribe
        || modalData.visibleModalReject
        || modalData.visibleModalSend
        || modalData.visibleModalTie)
    ) {
      setModalData((item) => ({
        ...item,
        visibleModalSubscribe: false,
        visibleModalReject: false,
        visibleModalSend: false,
        visibleModalTie: false,
        visibleModalClose: false
      }));
      getZDVLClear();
      thisDataGridInstance.instance.clearSelection();
    }
  }, [
    id,
    modalData.visibleModalReject,
    modalData.visibleModalSubscribe,
    modalData.visibleModalSend,
    modalData.visibleModalTie,
    thisDataGridInstance,
    okRequestModal,
    tabSelect,
    getZDVLClear
  ]);

  useEffect(() => {
    if (error) {
      setModalData((item) => ({
        ...item,
        visibleModalSubscribe: false,
        visibleModalReject: false,
        visibleModalSend: false,
        visibleModalTie: false,
        visibleModalClose: false
      }));
      getZDVLClear();
    }
  }, [error, getZDVLClear]);

  // Обновление данных
  const onClickUpdate = useCallback(() => {
    getZDVL({
      ...filterDataGrid,
      plantId
    });
  }, [filterDataGrid, getZDVL, plantId]);

  const getZdvlClosed = useCallback(
    () =>
      [...dataSource.selectList].filter(
        (el) => el && el.lineStatus === 4
      ),
    [dataSource.selectList]
  );

  const getZDVLRollsRender = useCallback((selectedList) => {
    if (
      selectedList.length
      && isSemiStock
    ) {
      if (!getZdvlClosed().length) {
        getZDVLRolls({
          zdvlLineNumId: Array.from(
            new Set([
              ...selectedList.map((el) => el.zdvlLineNumId)
            ])
          ),
          plantId,
          useFifo: true,
          filter: filterRollsDataGrid
        });
      } else if (tabSelect === 7) {
        modalErrorOpen({
          message: `${formatMessage('textModal').textZdvlClosedWarningP1}${
            getZdvlClosed()[0].lineId
          } ${formatMessage('textModal').textZdvlClosedWarningP2}${
            getZdvlClosed()[0].orderId
          } ${formatMessage('textModal').textZdvlClosedWarningP3}`,
          techInfo: '',
          types: 'error',
          title: formatMessage('textError').warning
        });
      }
    }
  }, [
    filterRollsDataGrid,
    getZDVLRolls,
    getZdvlClosed,
    isSemiStock,
    modalErrorOpen,
    plantId,
    tabSelect
  ]);

  /** Событие на выделение строк позиций заказа */
  const onZDVLSelectionChanged = useCallback(
    debounce(({ selectedRowsData, component }) => {
      if (selectedRowsData.length) {
        setHeadButtVisibol({ display: 'flex' });
      } else {
        setHeadButtVisibol({ display: 'none' });
      }
      setDataSource((item) => ({
        ...item,
        selectList: selectedRowsData
      }));
      if (selectedRowsData.length === 0) {
        getZDVLRollsFail();
      // } else {
      //   getZDVLRollsRender(selectedRowsData);
      }
    }, 500),
    [selectedRollsKeys, getZDVLRollsFail]
  );

  /** Событие на выделение строк рулонов */
  const onRollsSelectionChanged = useCallback(
    (selectedRowKeys) => {
      const prmIgnoreFIFO = permissions.includes('prmIgnoreFIFO');
      let selectedRows;
      if (selectedRowKeys.length === zdvlRolls.length) {
        selectedRows = selectedRowKeys;
      } else if (selectedRowKeys.length === 0) {
        if (prmIgnoreFIFO) {
          selectedRows = selectedRowKeys.concat(
            zdvlRolls
              .filter(({ checkbox }) => checkbox === 'RELATED_FIXED')
              .map(({ pieceNumId }) => pieceNumId)
          );
        } else {
          const isFixedRolls = zdvlRolls.some(
            (roll) => roll.checkbox === 'RELATED_FIXED'
          );

          if (isFixedRolls) {
            const zdvlRollsCopy = [...zdvlRolls].reverse();
            const fixedRollIndex = zdvlRollsCopy.findIndex(
              (roll) => roll.checkbox === 'RELATED_FIXED'
            ); // 1 (предпоследний)
            zdvlRollsCopy.splice(0, fixedRollIndex);
            selectedRows = zdvlRollsCopy.map((roll) => roll.pieceNumId);
          } else {
            selectedRows = selectedRowKeys;
          }
        }
      } else if (prmIgnoreFIFO) {
        selectedRows = selectedRowKeys.concat(
          zdvlRolls
            .filter(({ checkbox }) => checkbox === 'RELATED_FIXED')
            .map(({ pieceNumId }) => pieceNumId)
        );
      } else {
        let availableToCheck = null;
        let availableToUncheck = null;

        for (let i = 0; i < zdvlRolls.length; i += 1) {
          if (!selectedRollsKeys.includes(zdvlRolls[i].pieceNumId)) {
            availableToCheck = zdvlRolls[i].pieceNumId;
            break;
          }
        }

        for (let i = zdvlRolls.length - 1; i >= 0; i -= 1) {
          if (selectedRollsKeys.includes(zdvlRolls[i].pieceNumId)) {
            if (zdvlRolls[i].checkbox !== 'RELATED_FIXED') {
              availableToUncheck = zdvlRolls[i].pieceNumId;
              break;
            } else {
              break;
            }
          }
        }

        if (
          (availableToCheck && selectedRowKeys.includes(availableToCheck))
          || (availableToUncheck && !selectedRowKeys.includes(availableToUncheck))
        ) {
          selectedRows = selectedRowKeys;
        } else {
          modalErrorOpen({
            message: formatMessage('textError').textErrorFifo,
            types: 'error',
            title: formatMessage('textError').warning
          });
          selectedRows = selectedRollsKeys;
        }
      }

      setSelectedRollsKeys(() => selectedRows);
      if (zdvlRolls.length || dataSource.selectList) {
        setHeadButtVisibol({ display: 'flex' });
      } else {
        setHeadButtVisibol({ display: 'none' });
      }
    },
    [
      permissions,
      zdvlRolls,
      dataSource.selectList,
      selectedRollsKeys,
      modalErrorOpen
    ]
  );

  /** Строка для подстановки */
  const textZDVL = useMemo(() => {
    let temp = '';
    dataSource.selectList.forEach((item) => {
      temp = `${temp}${item.orderId} ${item.lineId}, `;
    });
    temp = trim(trim(temp, ' '), ',');
    return temp;
  }, [dataSource.selectList]);

  const closeHeaderButton = useCallback(() => {
    thisDataGridInstance.instance.clearSelection();
    setHeadButtVisibol({ display: 'none' });
  }, [thisDataGridInstance.instance]);

  const modalOnHiding = useCallback(() => {
    setModalData((item) => ({
      ...item,
      visibleModalSubscribe: false,
      visibleModalReject: false,
      visibleModalSend: false,
      visibleModalTie: false,
      visibleModalRid: false,
      visibleModalClose: false,
      visibleModalEmail: false
    }));
    if (rollsDataGridInstance && rollsDataGridInstance.instance) {
      rollsDataGridInstance.instance.clearSelection();
    }
  }, [rollsDataGridInstance]);

  /** Открытие модальных окон */
  const onClickSubscribe = useCallback(() => {
    setModalData((item) => ({
      ...item,
      visibleModalSubscribe: true
    }));
  }, []);

  const onClickReject = useCallback(() => {
    setModalData((item) => ({
      ...item,
      visibleModalReject: true
    }));
  }, []);

  /** Модальные окна подписать-отклонить и обновление заданий */
  const onClickPopupSubscribe = useCallback((ZDVLLine) => {
    getZDVLAccept({
      list: ZDVLLine ? ZDVLLine.map((item) => item.zdvlLineNumId)
        : dataSource.selectList.map((item) => item.zdvlLineNumId),
      filter: filterDataGrid
    });
  }, [dataSource.selectList, filterDataGrid, getZDVLAccept]);

  const onClickPopupReject = useCallback((ZDVLLine, mode) => {
    getZDVLDecline({
      list: mode === 'zdvlLine' ? ZDVLLine.map((item) => item.zdvlLineNumId)
        : dataSource.selectList.map((item) => item.zdvlLineNumId),
      filter: filterDataGrid
    });
  }, [dataSource.selectList, filterDataGrid, getZDVLDecline]);

  /** Решили выводить пользователям сообщения об удалении привязкки ПФ к ZDVL заказу вручную */
  // const onDeleteZDVLLine = useCallback((taskNumId, zdvlLineIds) => {
  //   deleteTaskZdvlLine({
  //     taskNumId,
  //     zdvlLineIds
  //   });
  // }, [deleteTaskZdvlLine]);
  //
  // const onDeleteReadyProduct = useCallback((operationNumId) => {
  //     deleteReadyProducts({
  //       operationNumId,
  //       plantId
  //     });
  //     closeHeaderButton();
  //   }, [closeHeaderButton, deleteReadyProducts, plantId]);
  //
  // const onConfirmDeleteZDVL = useCallback((status, action) => {
  //   modalErrorOpen({
  //     message: 'Вам необходимо самостоятельно отменить производство ГП.',
  //     techInfo: '',
  //     types: 'info',
  //     title: formatMessage('textError').warning
  //   });
  // }, [modalErrorOpen]);

  /** Модальное окно с подписанием и отправкой */
  const onClickPopupSend = useCallback(() => {
    getZDVLSend({
      zdvlOrderNumId: dataSource.selectZdvlOrderNumId,
      filter: filterDataGrid
    });
  }, [dataSource.selectZdvlOrderNumId, filterDataGrid, getZDVLSend]);

  /** Открытие модального окна с подписать и отправить */
  const onClickButtonZDVL = useCallback((data) => {
    setDataSource((item) => ({
      ...item,
      selectZdvlOrderNumId: data.zdvlOrderNumId,
      orderStatus: data.orderStatus,
      orderId: data.orderId,
      lineStatus: data.lineStatus
    }));
    setModalData((item) => ({
      ...item,
      visibleModalSend: true
    }));
  }, []);

  /** Печать заказа */
  const onClickPrint = useCallback(() => {
    getReportCreateNew({
      printFormat: 'PDF',
      reportParams: { docNumId: dataSource.selectZdvlOrderNumId },
      reportType: settings.useNewProcessSpec ? 'ZDVL_ORDER_NEW' : 'ZDVL_ORDER'
    });
    modalOnHiding();
  }, [dataSource, getReportCreateNew, modalOnHiding, settings.useNewProcessSpec]);

  const onClicksendZDVLNotice = useCallback(() => {
    if (loadingZDVLSendNotice) {
      return;
    }
    getZDVLSendNotice({
      plantId,
      list: dataSource.selectList
        .filter((el) => el.lineStatus !== 2)
        .map((el) => el.orderId),
      emails: emailsData
    });
  }, [
    dataSource.selectList,
    getZDVLSendNotice,
    plantId,
    emailsData,
    loadingZDVLSendNotice
  ]);

  // бесконечные запросы

  /** Кнопка для открытия модального окна */
  const buttonZDVL = useMemo(
    () => (buttonData) => {
      const { value, data } = buttonData;
      if (data.lineStatus === 4) {
        return (
          <Button
            type="default"
            stylingMode="text"
            className={style.buttonZdvl}
            onClick={() => onClickButtonZDVL(data)}
          >
            <div className={'colorRed dx-button-text'}>
              <span>{value}</span>
            </div>
          </Button>
        );
      }
      return (
        <div className={'td-right-cell-render'}>
          <Button
            text={value}
            type="default"
            stylingMode="text"
            onClick={() => onClickButtonZDVL(data)}
          />
        </div>
      );
    },
    [onClickButtonZDVL]
  );

  /** Получение рулонов */
  useEffect(() => {
    getZDVLRollsRender(dataSource.selectList);
  }, [dataSource.selectList, getZDVLRollsRender]);

  /** Закрытие модалки отпрвки уведомлений при успешном запросе */
  useEffect(() => {
    if (okRequestZDVLSendNotice) {
      setModalData((prev) => ({ ...prev, visibleModalEmail: false }));
    }
  }, [okRequestZDVLSendNotice]);

  /** Привязка рулонов к позиции заказа */
  const handleTieZDVLRolls = useCallback(() => {
    if (dataSource.selectedList || dataSource.selectList) {
      saveTask({
        zdvlLineIds: Array.from(
          new Set([
            ...dataSource.selectList.map((el) => el.zdvlLineNumId)
          ])
        ),
        taskDate: dataSource.taskDate,
        taskNumber: dataSource.taskNumber,
        semiProductIds: selectedRollsKeys
      });
      closeHeaderButton();
    }
  }, [
    closeHeaderButton,
    dataSource,
    saveTask,
    selectedRollsKeys
  ]);

  const createCloseMessage = useCallback(() => {
    if (dataSource.selectList.length) {
      const uniqueOrders = Array.from(
        new Set([
          ...dataSource.selectList.map((el) => el.orderId)
        ])
      ).join(', ');
      const uniqueLines = Array.from(
        new Set([
          ...dataSource.selectList.map((el) => el.lineId)
        ])
      ).join(', ');
      return `${formatMessage('textModal').textZdvlCloseP1} ${uniqueOrders} ${
        formatMessage('textModal').textZdvlCloseP2
      } ${uniqueLines}?`;
    }
    return '';
  }, [dataSource.selectList]);

  const handleCellPrepared = useCallback((e) => {
    setTimeout(() => {
      if (e.rowType === 'data' && e.columnIndex === 1) {
        if (
          e.data.checkbox === 'RELATED'
          || e.data.checkbox === 'RELATED_FIXED'
        ) {
          e.element.firstChild.children[5].children[1].firstChild.children[1].children[
            e.rowIndex
          ].className += ' grey';
        }
      }
    }, 0);
  }, []);

  const onClickBind = () => {
    if (zdvlRolls.length) {
      if (dataSource.selectList.length && [...dataSource.selectList].filter((item) => item
        && item.lineStatus !== 2 && item.orderStatus !== 2).length !== 0) {
        if ([...dataSource.selectList].filter((item) => item
          && (item.lineStatus === 3)).length !== 0) {
          modalErrorOpen({
            message: 'Некоторые из выбранных позиций заказа в статусе "отменена", исключите из выбора данные позиции.',
            techInfo: '',
            types: 'info',
            title: formatMessage('textError').warning
          });
        } else {
          modalErrorOpen({
            message: 'Перед созданием задания требуется принять позицию заказа и подписать заказ на переработку',
            techInfo: '',
            types: 'info',
            title: formatMessage('textError').warning
          });
        }
      } else {
        if (plantId === '8045' && dataSource.selectList.length) {
          const project = (dataSource.selectList[0].project !== null)
            ? dataSource.selectList[0].project
            : '';
          const orderId = (dataSource.selectList[0].orderId !== null)
            ? dataSource.selectList[0].orderId
            : '';
          const lineId = (dataSource.selectList[0].lineId !== null)
            ? dataSource.selectList[0].lineId
            : '';
          setDataSource((item) => ({
            ...item,
            taskNumber: `${project}/${orderId}/${lineId}`
          }));
        }
        setModalData((prev) => ({
          ...prev,
          visibleModalTie: true
        }));
      }
    } else {
      modalErrorOpen({
        message: 'Для данной позиции заказа нет подходящего ПФ',
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  };

  const onClickClose = () => {
    let created = false;
    dataSource.selectList.forEach((item) => {
      if (item.lineStatus === 1) {
        created = true;
      }
    });
    if (created) {
      modalErrorOpen({
        message: 'Выбранный заказ/позиции в статусе "Создан". Что бы закрыть заказ необходимо его подписать.',
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    } else {
      setModalData((prev) => ({
        ...prev,
        visibleModalClose: true
      }));
    }
  };

  // TODO: Проверять заказ на закрытие
  const isCanConfirm = useCallback(
    () =>
      dataSource.selectList.every(
        (el) =>
          el.lineStatusTitle !== 'Принята'
          && el.orderStatusTitle !== 'Отправлен'
      ),
    [dataSource.selectList]
  );

  /** Сброс выделенных строк при переключении фильтра */
  const onFilterChanged = useCallback(() => {
    setHeadButtVisibol({ display: 'none' });
    thisDataGridInstance.instance.deselectAll();
    setDataSource({ ...dataSource,
      focusedRow: null,
      selectList: [] });
  }, [dataSource, thisDataGridInstance.instance]);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterDataGrid({ ...filterDataGrid, filter: value });
    }
  }, [filterDataGrid]);

  /** Текcт для модального окна обновления ZDVL заказа или позиции заказа */
  // eslint-disable-next-line consistent-return
  const renderUpdateZDVLText = useMemo(() => {
    if (statusData) {
      if (statusData.updateCase === 1) {
        return (
          // eslint-disable-next-line max-len
          <span>
            {`По заказу №${statusData.item[0].orderId}, позиция №${statusData.item[0].lineId}, изменена.\nПринять позицию заказа?`}
          </span>
        );
      } if (statusData.updateCase === 2) {
        return (
          // eslint-disable-next-line max-len
          <span>
            {`Предыдущая версия Заказа №${statusData.item[0].orderId}, позиция №${statusData.item[0].lineId} была изменена\nи будет исключена из Задания №${statusData.item[0].taskNumber}.`}
          </span>
        );
      } if (statusData.updateCase === 3) {
        return (
          // eslint-disable-next-line max-len
          <span>
            {`Заказ №${statusData.item[0].orderId}, позиция №${statusData.item[0].lineId} изменена.\nПри принятии изменений позиция заказа будет удалена из задания,\nа так же не подтвержденное производство будет удалено.\n Принять изменения?`}
          </span>
        );
      }
      return (
        // eslint-disable-next-line max-len
        <span>
          {`Заказ №${statusData.item[0].orderId}, позиция №${statusData.item[0].lineId} изменена.\nНеобходимо откатить производство, создать новое задание и ввести производство заново.\nПринять изменения?`}
        </span>
      );
    }
    return (
      <span>Ошибка в данных, обратитесь в службу поддержки.</span>
    );
  }, [statusData]);

  /** Кнопки для модального окна обновления ZDVL заказа или позиции заказа */
  // eslint-disable-next-line consistent-return
  const renderUpdateZDVLButtons = useMemo(() => {
    if (statusData) {
      if (statusData.updateCase === 1 || statusData.updateCase === 2) {
        return (
          <div className="formButton">
            <Button type="default"
                    stylingMode="contained"
                    width={260}
                    onClick={() => {
                      // if (statusData.updateCase === 2) {
                      //   // onConfirmDeleteZDVL(statusData.updateCase, 'confirm');
                      //   onDeleteZDVLLine(statusData.item[0].taskNumId,
                      //     [statusData.item.map((item) => item.zdvlLineNumId)]);
                      // }
                      onClickPopupSubscribe(statusData.item);
                      closeHeaderButton();
                      updateZDVLModalClose();
                    }}
            >
              <LoadIndicator className="indicator" visible={loadingUpdateZDVL} />
              <span>{formatMessage('textButton').confirm}</span>
            </Button>
            <Button type="default"
                    stylingMode="contained"
                    width={260}
                    onClick={() => {
                      // if (statusData.updateCase === 2) {
                      //   // onConfirmDeleteZDVL(statusData.updateCase, 'reject');
                      //   onDeleteZDVLLine(statusData.item[0].taskNumId,
                      //     [statusData.item.map((item) => item.zdvlLineNumId)]);
                      // }
                      onClickPopupReject(statusData.item, 'zdvlLine');
                      closeHeaderButton();
                      updateZDVLModalClose();
                    }}
            >
              <LoadIndicator className="indicator" visible={loadingUpdateZDVL} />
              <span>{formatMessage('textButton').reject}</span>
            </Button>
            <Button text={formatMessage('textButton').cancel}
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      closeHeaderButton();
                      updateZDVLModalClose();
                    }}
            />
          </div>
        );
      }
      return (
        <div className="formButton">
          <Button type="default"
                  stylingMode="contained"
                  width={260}
                  onClick={() => {
                    // onConfirmDeleteZDVL(statusData.updateCase, 'confirm');
                    // onDeleteReadyProduct(statusData.item[0].operationNumId);
                    // onDeleteZDVLLine(statusData.item[0].taskNumId,
                    //   [statusData.item.map((item) => item.zdvlLineNumId)]);
                    onClickPopupSubscribe(statusData.item);
                    closeHeaderButton();
                    updateZDVLModalClose();
                  }}
          >
            <LoadIndicator className="indicator" visible={loadingUpdateZDVL} />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
          <Button text={formatMessage('textButton').no}
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    closeHeaderButton();
                    updateZDVLModalClose();
                  }}
          />
        </div>
      );
    }
  }, [
    closeHeaderButton,
    loadingUpdateZDVL,
    onClickPopupReject,
    onClickPopupSubscribe,
    statusData,
    updateZDVLModalClose
  ]);

  return (
    <>
      <HeaderButtonMVP headButtVisibol={headButtVisibol}>
        <Button
          icon={'close'}
          stylingMode={'text'}
          onClick={closeHeaderButton}
        />
        <span className={'span-first'}>
          {`${formatMessage('textDataGrid').selectOrders} - ${
            dataSource.selectList.length
          }`}
        </span>
        {dataSource.selectList.length > 0
          && isCanConfirm()
          && [...dataSource.selectList].filter((el) => el && (el.lineStatus === 3
              || el.lineStatus === 5
              || el.lineStatus === 6)).length === 0
          ? (
            <>
              <Button
              text={formatMessage('textButton').confirm}
              type={'default'}
              stylingMode={'contained'}
              disabled={!!getZdvlClosed().length || loadingData || loadingRolls}
              onClick={onClickSubscribe}
            />
              <Button
              text={formatMessage('textButton').reject}
              type={'danger'}
              stylingMode={'contained'}
              disabled={!!getZdvlClosed().length || loadingData || loadingRolls}
              elementAttr={{ class: style.redButt }}
              onClick={onClickReject}
            />
            </>
          ) : null}
        {isSemiStock && (
        <Button
          text={formatMessage('textButton').createTask}
          type={'default'}
          disabled={!!getZdvlClosed().length
            || loadingData
            || loadingRolls
            || [...dataSource.selectList].filter((item) => item
              && (item.lineStatus === 3)).length !== 0}
          stylingMode={'contained'}
          onClick={onClickBind}
        />
        )}
        {/* TODO: перенос кнопки в задания */}
        <Button
          text={formatMessage('textButton').closeOrder}
          type={'danger'}
          disabled={!!getZdvlClosed().length || loadingData || loadingRolls}
          stylingMode={'contained'}
          onClick={onClickClose}
        />
        {
          dataSource.selectList.filter((el) => el.lineStatus !== 2).length
          && permissions.length && settings.useZdvlNewEmail
            ? (
              <Button
                text={formatMessage('textButton').notification}
                type={'default'}
                stylingMode={'contained'}
                onClick={() => setModalData((prev) => ({...prev, visibleModalEmail: true}))}
              />
            )
            : ''
        }

        {/*
        TODO: перенос кнопки в задания
        <Button
          text={formatMessage('textButton').rid}
          type={'default'}
          stylingMode={'contained'}
          onClick={() =>
            setModalData((prev) => ({
              ...prev,
              visibleModalRid: true
            }))}
        /> */}
      </HeaderButtonMVP>

      <SplitterLayout>
        <div className={style.topSide}>
          <p className={style.title}>
            {formatMessage('textTabRecyclingOrders')}
          </p>
          <DataGridMVP
            dataSource={(plantId !== 8045 ? (listZdvl.filter((item) => (item.key !== 'additionalStatus'))) : listZdvl)}
            className={`${style.topTable} zdvlOrders`}
            keyExpr="zdvlLineNumId"
            setDataGridInstance={setThisDataGridInstance}
            onSelectionChanged={onZDVLSelectionChanged}
            filterDataGrid={filterDataGrid}
            onFilterChanged={onFilterChanged}
            setFilterDataGrid={setFilterDataGrid}
            setStateStoringName="dataGridRecyclingOrdersListUpd"
            dataGridOnOptionChanged={dataGridOnOptionChanged}
            altWeightNettoField="capacityPipe"
            showSumBrutto={false}
            tText={formatMessage('textPeriod')}
            loadingData={loadingZDVL || semiProductsReducer.loading}
            isDataLoading={loadingData}
            visibleButtonQRCode={false}
            visibleInfoIcon={false}
            visibleButtonDateRangePicker
            visibleActyalButton={false}
            visibleSummary
            visibleButtonCheckAll
            visibleButtonUpdate
            onClickUpdate={onClickUpdate}
            scrollingMode="standard"

          >
            {columnDataGrid.map((item) => (
                (!settings.useZdvlNewEmail && item.dataField === 'noticeDatetime')
                || (item.dataField === 'additionalStatus' && plantId !== '8045')
                    ? null
                    : (
                <Column
                  dataField={item.dataField}
                  caption={
                    formatMessage('textTableRecyclingOrders')[item.dataField]
                  }
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
                  width={item.width ? item.width : undefined}
                  cellRender={
                    item.dataField !== 'orderId' ? item.cellRender : buttonZDVL
                  }
                />
                )
            ))}
          </DataGridMVP>
        </div>
        {isSemiStock && (
        <div className={style.bottomSide}>
          <p className={style.bottomTitle}>
            {formatMessage('textBindChangeRolls')}
          </p>
          <DataGridMVP
            dataSource={zdvlRolls}
            keyExpr="pieceNumId"
            className={style.bottomTable}
            setDataGridInstance={setRollsDataGridInstance}
            onCellPrepared={handleCellPrepared}
            filterDataGrid={filterRollsDataGrid}
            setFilterDataGrid={setFilterRollsDataGrid}
            selectedRowKeys={selectedRollsKeys}
            altWeightNettoField="quantity"
            altWeightBruttoField="quantityAvailable"
            tText={formatMessage('textPeriod')}
            setStateStoringName="dataGridRecyclingRollsList"
            loadingData={loadingRolls || loadingZDVL}
            visibleButtonQRCode={false}
            visibleInfoIcon={false}
            visibleButtonDateRangePicker
            visibleActyalButton={false}
            onCellClick={(e) => {
              if (e.rowType === 'header') {
                if (
                  e.cellElement.firstChild.getAttribute('aria-checked')
                    === 'false'
                  || e.cellElement.firstChild.getAttribute('aria-checked')
                    === 'mixed'
                ) {
                  onRollsSelectionChanged([]);
                } else if (
                  e.cellElement.firstChild.getAttribute('aria-checked')
                  === 'true'
                ) {
                  onRollsSelectionChanged(zdvlRolls.map((el) => el.pieceNumId));
                }
              } else if (e.column && e.column.type === 'selection') {
                onRollsSelectionChanged(e.component.getSelectedRowKeys());
              }
            }}
            visibleSummary
            visibleButtonCheckAll
            onClickUpdate={() => {}}
            scrollingMode="standard"
          >
            {rollsColumnDataGrid.map((item) => (
              <Column
                dataField={item.dataField}
                caption={
                  formatMessage('textTableRecyclingOrders')[item.dataField]
                }
                visible={!item.notVisible}
                allowSearch
                allowFiltering
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
              />
            ))}
          </DataGridMVP>
        </div>
        )}
      </SplitterLayout>

      <PopupMVP
        visible={modalData.visibleModalTie}
        onHiding={modalOnHiding}
        title={formatMessage('textButton').createTask}
      >
        <div className="formData">
          <div className="optionsRow">
            <div className="optionsData">
              <span>{formatMessage('textButton').createTask}</span>
              <TextBox
                value={dataSource.taskNumber}
                onValueChanged={({ value }) =>
                  setDataSource({
                    ...dataSource,
                    taskNumber: value
                  })}
                stylingMode="outlined"
              />
            </div>
            <div className="optionsData">
              <span>{formatMessage('textData').date}</span>
              <DateBox
                type="date"
                displayFormat="dd.MM.yyyy"
                value={dataSource.taskDate}
                onValueChanged={({ value }) =>
                  setDataSource({
                    ...dataSource,
                    taskDate: normalizeDateToSend(value)
                  })}
                width="100%"
                stylingMode="outlined"
                openOnFieldClick
                useMaskBehavior
              />
            </div>
          </div>
          <div className="formButton">
            <Button
              text={formatMessage('textButton').cancel}
              type="default"
              stylingMode="text"
              onClick={modalOnHiding}
            />
            <Button
              type="default"
              stylingMode="contained"
              width={260}
              onClick={handleTieZDVLRolls}
            >
              <LoadIndicator
                className="indicator"
                visible={taskReducer.taskSave.loading}
              />
              <span>{formatMessage('textButton').create}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>

      {/** модальные окна "Подписать" или "Отклонить" */}
      <PopupMVP
        visible={modalData.visibleModalSubscribe}
        onHiding={modalOnHiding}
        title={formatMessage('textButton').confirm}
      >
        <div className="formData">
          <p>{`${formatMessage('textModal').textSubscribe} ${textZDVL} ?`}</p>
          <div className="formButton">
            <Button
              text={formatMessage('textButton').no}
              type="default"
              stylingMode="text"
              onClick={modalOnHiding}
            />
            <Button
              type="default"
              stylingMode="contained"
              width={260}
              onClick={() => (
                onClickPopupSubscribe(null)
              )}
            >
              <LoadIndicator className="indicator" visible={loadingModal} />
              <span>{formatMessage('textButton').yes}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
      <PopupMVP
        visible={modalData.visibleModalReject}
        onHiding={modalOnHiding}
        title={formatMessage('textButton').reject}
      >
        <div className="formData">
          <p>{`${formatMessage('textModal').textReject} ${textZDVL} ?`}</p>
          <div className="formButton">
            <Button
              text={formatMessage('textButton').no}
              type="default"
              stylingMode="text"
              onClick={modalOnHiding}
            />
            <Button
              type="default"
              stylingMode="contained"
              width={260}
              onClick={onClickPopupReject}
            >
              <LoadIndicator className="indicator" visible={loadingModal} />
              <span>{formatMessage('textButton').yes}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
      {/** Модальное окно для подписания */}
      <PopupMVP
        visible={modalData.visibleModalSend}
        onHiding={modalOnHiding}
        title={
          // eslint-disable-next-line no-nested-ternary
          dataSource.orderStatus === 1
            ? formatMessage('textModal').textSignAndSend
            : formatMessage('textModal').textOpen
        }
      >
        <div className="formData">
          <p>
            {// eslint-disable-next-line no-nested-ternary
            dataSource.orderStatus === 1
              ? `${formatMessage('textModal').textSignAndSendOrder} ${
                dataSource.orderId
              } ?`
              : `${formatMessage('textModal').textOpenOrder} ${
                dataSource.orderId
              } ?`
            }
          </p>
          {dataSource.orderStatus === 2 ? (
            <div className="formButton">
              <Button
                text={formatMessage('textButton').no}
                type="default"
                stylingMode="text"
                onClick={modalOnHiding}
              />
              <Button
                text={formatMessage('textButton').yes}
                type="default"
                stylingMode="contained"
                onClick={onClickPrint}
              />
            </div>
          ) : (
            <div className="formButton">
              <Button
                text={formatMessage('textButton').print}
                type="default"
                stylingMode="contained"
                onClick={onClickPrint}
              />
              <Button
                text={formatMessage('textButton').no}
                type="default"
                stylingMode="text"
                onClick={modalOnHiding}
              />
              <Button
                type="default"
                stylingMode="contained"
                width={260}
                onClick={onClickPopupSend}
              >
                <LoadIndicator className="indicator" visible={loadingModal} />
                <span>{formatMessage('textButton').yes}</span>
              </Button>
            </div>
          )}
        </div>
      </PopupMVP>
      <PopupMVP
        visible={modalData.visibleModalClose}
        onHiding={modalOnHiding}
        title={formatMessage('textButton').closeOrder}
      >
        <div className="formData">
          <p>{modalData.visibleModalClose && createCloseMessage()}</p>
          <div className="formButton">
            <Button
              text={formatMessage('textButton').no}
              type="default"
              stylingMode="text"
              onClick={modalOnHiding}
            />
            <Button
              type="default"
              stylingMode="contained"
              width={260}
              onClick={() => {
                closeZDVL([
                  ...dataSource.selectList.map((el) => el.zdvlLineNumId)
                ]);
                closeHeaderButton();
              }}
            >
              <LoadIndicator className="indicator" visible={loadingClose} />
              <span>{formatMessage('textButton').yes}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
      <PopupMVP
        visible={visibleUpdateZDVL}
        onHiding={() => {
          closeHeaderButton();
          updateZDVLModalClose();
        }}
        title={formatMessage('textModal').textUpdateZDVL}
      >
        <div className="formData">
          <p>{ visibleUpdateZDVL && renderUpdateZDVLText }</p>
          { visibleUpdateZDVL && renderUpdateZDVLButtons }
        </div>
      </PopupMVP>
      <PopupMVP
        visible={modalData.visibleModalEmail}
        onHiding={modalOnHiding}
        title={formatMessage('textModal').textUpdateZDVL}
      >
        <div className="formData">
          <p>
            Список заказов:
            {
              dataSource.selectList
                .filter((el) => el.lineStatus !== 2)
                .map((el) => ` ${el.orderId};`)
            }
          </p>
          <TextBox
            value={emailsData}
            onValueChanged={({ value }) => setEmailsData(value)}
            stylingMode="outlined"
            placeholder="Дополнительные получатели"
          />
          <div className="formButton">
            <Button
              text={formatMessage('textButton').no}
              type="default"
              stylingMode="text"
              onClick={modalOnHiding}
            />
            <Button
              type="default"
              stylingMode="contained"
              width={260}
              onClick={onClicksendZDVLNotice}
            >
              <LoadIndicator className="indicator" visible={loadingZDVLSendNotice} />
              <span>{formatMessage('textButton').send}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>

    </>
  );
};
export default RecyclingOrders;
